import { useEffect, useRef, useState } from "react";
import "./StorySection.css";

function StorySection() {
  const [show, setShow] = useState(false);

const sectionRef = useRef(null);

useEffect(() => {

  const observer = new IntersectionObserver(
    ([entry]) => {

      if (entry.isIntersecting) {
        setShow(true);
      }

    },
    {
      threshold: 0.2
    }
  );

  if (sectionRef.current) {
    observer.observe(sectionRef.current);
  }

  return () => {
    if (sectionRef.current) {
      observer.unobserve(sectionRef.current);
    }
  };

}, []);
return (
  <>
    <section ref={sectionRef}>
      <div className="story-panel">

        <div className={`story-image ${show ? "show" : ""}`}>
          <img src={process.env.PUBLIC_URL + "/Aethearia Img.jpeg"} 
            
            alt="Our Story" 
          />
        </div>

        <div className={`story-copy ${show ? "show" : ""}`}>
          <span className="story-label">
            Our Story
          </span>

          <h2 style={{textTransform:"capitalize"}}>
            Born from stillness.<br />
            Built with intention.
          </h2>

          <p style={{textTransform:"capitalize"}}>
            Aethearia was created as a devotion to slow living, inner alchemy
            and the sacred art of self-connection. Every product and piece is
            mindfully crafted to elevate your everyday into something sacred.
          </p>

          <a href="/about" style={{ textTransform: "capitalize" }}>
            Discover our journey →
          </a>
        </div>

      </div>
    </section>

    {/* Big Banner */}
    {/* <section className="story-banner">
    
    </section> */}
  </>
);
}

export default StorySection;